<template>
  <div class="promo-box">
    <div class="title-bar">Promo Codes</div>
    
    <div class="active-codes-box">
      <div class="label-bar">
        <div class="code-label">
          <span>Code</span>
        </div>
        <div class="plan-label">Plan Name</div>
        <div class="date-label">Expiration Date</div>
        <div class="share-label">Share</div>
        <div class="delete-label">Delete</div>
      </div>
      <PromoCode v-for="code in activeCodes" :data="code" :key="code._id" @reload="onReload"/>
      <div class="no-codes" v-if="activeCodes.length == 0">No codes</div>
    </div>

    <div class="bottom-bar">
      <div class="generate-button-box">
        <div class="button" @click="generateCodes">
          <font-awesome-icon icon="plus" class="icon"/>
          <div class="title">Generate codes</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from 'axios'
import PromoCode from './PromoCode'

export default {
  name: 'PromoCodes',
  components: {
    PromoCode
  },
  props: {
    generatorState: Boolean
  },
  data() {
    return {
      activeCodes: []
    }
  },
  methods: {
    loadActivePromoCodes() {
      axios({
        method: 'post',
        url: `${process.env.VUE_APP_SERVER_URL}loadActivePromoCodes`,
        headers: {
          Authorization: 'Bearer ' + localStorage.getItem('token') 
        },
      }).then(data => {
        this.activeCodes = data.data.codes;
      }).catch(err => {
        console.log(err);
      })
    },
    onReload() {
      this.loadActivePromoCodes();
    },
    generateCodes() {
      this.$emit('openGenerator');
    }
  },
  watch: {
    generatorState() {
      this.loadActivePromoCodes();
    }
  },
  mounted() {
    this.loadActivePromoCodes();
  }
}
</script>

<style lang="scss" scoped>
.promo-box {
  width: 100%;
  height: auto;
  display: flex;
  flex-direction: column;
  margin-bottom: 4rem;
  background-color: rgb(224, 224, 224);
  border-radius: 0.3rem;
  overflow: hidden;

  .title-bar {
    width: 100%;
    height: 4rem;
    display: flex;
    justify-content: center;
    align-items: center;
    background-color: #11b6a6af;
    font-size: 1.5rem;
    color: white;
  }

  .active-codes-box {
    width: 100%;
    height: auto;
    display: flex;
    flex-direction: column;

    @media (max-width: 700px) {
      align-items: center;
      padding-bottom: 1rem;
    }

    .label-bar {
      width: 100%;
      height: 2rem;
      display: flex;
      color: white;
      background-color: rgba(199, 199, 199, 0.411);
      @media (max-width: 700px) {
        display: none;
      }

      .code-label {
        flex: 3;
        height: 100%;
        display: flex;
        align-items: center;
        color: rgb(134, 134, 134);
        font-weight: bold;
        
        span {
          padding-left: 1rem;
        }
      }

      .plan-label {
        flex: 1;
        height: 100%;
        display: flex;
        align-items: center;
        justify-content: center;
        color: rgb(134, 134, 134);
        font-weight: bold;
        border-left: 2px dashed rgb(199, 199, 199);
      }

      .date-label {
       flex: 1.5;
        height: 100%;
        display: flex;
        align-items: center;
        justify-content: center;
        color: rgb(134, 134, 134);
        font-weight: bold;
        border-left: 2px dashed rgb(199, 199, 199);
      }

      .share-label {
        flex: 0.75;
        height: 100%;
        display: flex;
        align-items: center;
        justify-content: center;
        color: rgb(134, 134, 134);
        font-weight: bold;
        border-left: 2px dashed rgb(199, 199, 199);
      }

      .delete-label {
        flex: 0.75;
        height: 100%;
        display: flex;
        align-items: center;
        justify-content: center;
        color: rgb(134, 134, 134);
        font-weight: bold;
        border-left: 2px dashed rgb(199, 199, 199);
      }
    }

    .no-codes {
      width: 100%;
      height: 4rem;
      display: flex;
      justify-content: center;
      align-items: center;
      padding-left: 1rem;
      color: rgb(134, 134, 134);
      font-weight: bold;
    }
  }

  .bottom-bar {
    width: 100%;
    height: 4rem;
    display: flex;
    justify-content: flex-end;
    align-items: center;
    background-color: rgba(199, 199, 199, 0.822);
    font-size: 1.5rem;
    color: white;

    .generate-button-box {
      width: auto;
      height: 100%;
      display: flex;
      justify-content: center;
      align-items: center;

      .button {
        display: flex;
        align-items: center;
        margin-right: 2rem;
        transition: 0.3s;

        &:hover {
          cursor: pointer;
          color: rgb(165, 165, 165);
        }

        .icon {
          margin-right: 0.5rem;
        }
        .title {
          padding-bottom: 0.05rem;
        }
      }
    }
  }
}
</style>